import Inherit from '../../core/inherit';
import { TraditionalStores } from '../common';
import ShelfController from '../../core/shelf.controller';
import PriceDelegate from './price.delegate';

class PriceController extends Inherit(ShelfController, PriceDelegate) {
    async initialize() {
        let prices = [];
        try {
            if (this.isAuthenticated) {
                const priceLists = await this.data.fetchPrices();
                prices = await this.formatPrices(priceLists);
            } else this.navigateLogin();
        } catch (error) {
            console.error('Error loading price lists:', error);
        } finally {
            // Always leave the loading state, even with no lists or a failed request.
            this.setState({ prices, rows: prices, loading: false });
        }
    }

    async formatPrices(prices) {
        // The API answers 404 `{ message }` when there are no lists yet: treat anything but an array as none.
        if (!Array.isArray(prices) || prices.length === 0) return [];
        const clientList = await this.data.fetchClients();
        const clients = new Map((Array.isArray(clientList) ? clientList : []).map((client) => [client._id, client]));
        const formattedPrices = await Promise.all(
            prices?.map(async (price) => {
                const itsTraditional = TraditionalStores.find((store) => store.value === price.type);

                let storeName = '';

                if (itsTraditional !== undefined) {
                    storeName = TraditionalStores.filter((store) => store.value === price.type)[0].label;
                } else {
                    const client = clients.get(price.type);
                    storeName = client?.name;
                }

                const channel = itsTraditional ? 'TRADICIONAL' : 'MODERNO';

                return {
                    type: storeName,
                    channel: channel,
                    active: price?.active,
                    id: price.type,
                };
            })
        );

        return formattedPrices || [];
    }
}

export default PriceController;
